import { useState } from 'react';

import { GekoppeldeInzet } from '@/components/detailPanel/types/types';
import { sortGekoppeldeInzetten } from '@/components/detailPanel/utils/utils';
import CollapsibleContainer from '@/components/UI/Collapsible/CollapsibleContainer';
import { Eenheid } from '@/types/werklijnenInline';

import SamenstellingRow from './SamenstellingRow';

import styles from '../DetailPanel.module.css';

type SamenstellingProps = {
  handleInzetClick?: (inzetId?: string, werklijnId?: string) => void;
  inzetId?: string;
  eenheid?: Eenheid;
  geaccepteerdConflict?: boolean;
  samenstelling?: string;
  geplandeTreinSamenstelling?: {
    samenstelling: string;
    aantalZitplaatsen: number;
    volNorm: number;
  };
  aantalZitplaatsen?: number;
  treinnummer?: string | number;
  inzetPositie?: string | number;
  gekoppeldeInzetten?: GekoppeldeInzet[];
};

export default function Samenstelling({
  handleInzetClick,
  geaccepteerdConflict,
  inzetId,
  eenheid,
  samenstelling,
  geplandeTreinSamenstelling,
  aantalZitplaatsen,
  treinnummer,
  inzetPositie,
  gekoppeldeInzetten = [],
}: Readonly<SamenstellingProps>) {
  const [openSamenstelling, setOpenSamenstelling] = useState(true);

  // Create a new sorted array without mutating the original
  const sortedGekoppeldeInzetten = [...gekoppeldeInzetten].sort(sortGekoppeldeInzetten);

  return (
    <div>
      <CollapsibleContainer title='Samenstelling' open={openSamenstelling} onOpenChange={setOpenSamenstelling}>
        <div className={styles.volgendeInzetSamenstelling}>
          <div style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            {inzetPositie === 'V' || inzetPositie === '' ? (
              <SamenstellingRow
                inzetId={inzetId}
                geaccepteerdConflict={geaccepteerdConflict}
                geplandeTreinSamenstelling={geplandeTreinSamenstelling}
                eenheid={eenheid}
                samenstelling={samenstelling ?? 'Onbekend'}
                aantalZitplaatsen={aantalZitplaatsen}
                treinnummer={treinnummer}
                inzetPositie={inzetPositie}
                key={`row-${inzetId}-${eenheid?.nummer ?? 'main'}`}
              />
            ) : null}
            {sortedGekoppeldeInzetten[0] && (
              <SamenstellingRow
                inzetId={sortedGekoppeldeInzetten[0].inzetId}
                handleInzetClick={handleInzetClick}
                eenheid={sortedGekoppeldeInzetten[0].eenheid}
                key={`row-${sortedGekoppeldeInzetten[0].inzetId}-${sortedGekoppeldeInzetten[0].eenheid?.nummer}`}
                geplandeTreinSamenstelling={sortedGekoppeldeInzetten[0].geplandeTreinSamenstelling}
                samenstelling={sortedGekoppeldeInzetten[0].treinSamenstelling?.samenstelling}
                aantalZitplaatsen={sortedGekoppeldeInzetten[0].treinSamenstelling?.aantalZitplaatsen}
                treinnummer={treinnummer}
                werklijnId={sortedGekoppeldeInzetten[0].werklijnId}
                geaccepteerdConflict={sortedGekoppeldeInzetten[0].geaccepteerdConflict}
                inzetPositie={sortedGekoppeldeInzetten[0].inzetPositie}
                showPositieShort={true}
              />
            )}
            {inzetPositie === 'M' ? (
              <SamenstellingRow
                inzetId={inzetId}
                eenheid={eenheid}
                geaccepteerdConflict={geaccepteerdConflict}
                geplandeTreinSamenstelling={geplandeTreinSamenstelling}
                samenstelling={samenstelling ?? 'Onbekend'}
                aantalZitplaatsen={aantalZitplaatsen}
                treinnummer={treinnummer}
                inzetPositie={inzetPositie}
                key={`row-${inzetId}-${eenheid?.nummer ?? 'main'}`}
              />
            ) : null}
            {sortedGekoppeldeInzetten[1] && (
              <SamenstellingRow
                inzetId={sortedGekoppeldeInzetten[1].inzetId}
                handleInzetClick={handleInzetClick}
                eenheid={sortedGekoppeldeInzetten[1].eenheid}
                key={`row-${sortedGekoppeldeInzetten[1].inzetId}-${sortedGekoppeldeInzetten[1].eenheid?.nummer}`}
                samenstelling={sortedGekoppeldeInzetten[1].treinSamenstelling?.samenstelling}
                geplandeTreinSamenstelling={sortedGekoppeldeInzetten[1].geplandeTreinSamenstelling}
                aantalZitplaatsen={sortedGekoppeldeInzetten[1].treinSamenstelling?.aantalZitplaatsen}
                treinnummer={treinnummer}
                werklijnId={sortedGekoppeldeInzetten[1].werklijnId}
                geaccepteerdConflict={sortedGekoppeldeInzetten[1].geaccepteerdConflict}
                inzetPositie={sortedGekoppeldeInzetten[1].inzetPositie}
                showPositieShort={true}
              />
            )}
            {sortedGekoppeldeInzetten[2] && (
              <SamenstellingRow
                inzetId={sortedGekoppeldeInzetten[2].inzetId}
                handleInzetClick={handleInzetClick}
                eenheid={sortedGekoppeldeInzetten[2].eenheid}
                geaccepteerdConflict={sortedGekoppeldeInzetten[2].geaccepteerdConflict}
                key={`row-${sortedGekoppeldeInzetten[2].inzetId}-${sortedGekoppeldeInzetten[2].eenheid?.nummer}`}
                samenstelling={sortedGekoppeldeInzetten[2].treinSamenstelling?.samenstelling}
                geplandeTreinSamenstelling={sortedGekoppeldeInzetten[2].geplandeTreinSamenstelling}
                aantalZitplaatsen={sortedGekoppeldeInzetten[2].treinSamenstelling?.aantalZitplaatsen}
                treinnummer={treinnummer}
                werklijnId={sortedGekoppeldeInzetten[2].werklijnId}
                inzetPositie={sortedGekoppeldeInzetten[2].inzetPositie}
                showPositieShort={true}
              />
            )}
            {inzetPositie === 'A' ? (
              <SamenstellingRow
                inzetId={inzetId}
                eenheid={eenheid}
                geaccepteerdConflict={geaccepteerdConflict}
                geplandeTreinSamenstelling={geplandeTreinSamenstelling}
                samenstelling={samenstelling ?? 'Onbekend'}
                aantalZitplaatsen={aantalZitplaatsen}
                treinnummer={treinnummer}
                inzetPositie={inzetPositie}
                key={`row-${inzetId}-${eenheid?.nummer ?? 'main'}`}
              />
            ) : null}
          </div>
        </div>
      </CollapsibleContainer>
    </div>
  );
}
